import { PageLoading } from '@/components';
import { AuthProviderConfig, initReactQueryAuth } from '@/libs/auth';
import {
  login,
  me,
  register,
  type RegisterRequest,
  type Request as LoginRequest,
} from '@/pages/login/api';
import { AuthUser } from '@/pages/login/types';
import storage from '@/utils/storage';
import { AxiosError } from 'axios';
import React from 'react';
import { Navigate } from 'react-router-dom';
import { Message } from '@arco-design/web-react';
import { LoginPath } from '@/config';

async function loadUser() {
  // 判断是否可以发送请求
  if (storage.getToken()) {
    const data = await me();
    return data.data;
  }
  return null;
}

async function loginFn(data: LoginRequest) {
  const response = await login(data);
  storage.setToken(response.data.token);
  const meRes = await me();
  return meRes.data;
}

async function registerFn(data: RegisterRequest) {
  const response = await register(data);
  return response.data;
}

async function logoutFn() {
  Message.info({
    content: '请重新登录',
    duration: 1000,
    onClose: () => {
      storage.clearToken();
      window.location.href = LoginPath;
    },
  });
}

const authConfig: AuthProviderConfig<AuthUser | null, AxiosError> = {
  loadUser,
  loginFn,
  logoutFn,
  registerFn,
  LoaderComponent() {
    return <PageLoading />;
  },
};

export const { AuthProvider, useAuth } = initReactQueryAuth<
  AuthUser | null,
  AxiosError,
  LoginRequest,
  RegisterRequest
>(authConfig);

type GuardProps = {
  authGuard: boolean;
  guestGuard: boolean;
  children: JSX.Element;
};

// guest:true , authGuard:false => only guest entry
// guest:false, authGuard:true => only auth entry
// guest:false, authGuard:false => no check
export function Guard({ children, authGuard, guestGuard }: GuardProps) {
  const auth = useAuth();
  // const location = useLocation();
  // only guest
  if (guestGuard && auth.user) {
    return <Navigate to="/" replace />;
  }
  // only auth
  if (authGuard && !auth.user) {
    window.location.href = 'https://baidu.com';
    // return <Navigate to={LoginPath} state={{ from: location }} replace />;
    return null;
  }
  return children;
}
